import type {
    TFontWeightValid,
    TLineHeight,
    TFontSize,
    IFontPreset,
    TTransform,
    TLetterSpacing,
} from '../models';

/**
 * Функция собирающая объект настройки начертания текста
 * @param fontSize Размер шрифта
 * @param lineHeight Между строчный интервал
 * @param fontWeight Жирность шрифта
 * @param textTransform Трансформации текста (С большой буквы, все большие, все маленькие)
 * @param letterSpacing Межбуквенный интервал
 * @returns Объект настройки
 */
export const buildFontPreset = (
    fontSize: TFontSize,
    lineHeight?: TLineHeight,
    fontWeight?: TFontWeightValid,
    textTransform?: TTransform,
    letterSpacing?: TLetterSpacing
): IFontPreset => ({
    fontSize,
    lineHeight,
    fontWeight,
    textTransform,
    letterSpacing,
});
